/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_TitleInputs */



/**
* | output |
* | --- |
* | "Audio Description Export" |
*
* @param {Audio_Description_Export_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_title = /** @type {((inputs?: Audio_Description_Export_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation de la description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibung exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione della descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт аудиоописания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación de descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频描述导出")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ説明のエクスポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण निर्यात करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportar descrição de áudio")
	return /** @type {LocalizedString} */ ("Audio Description Export")
});